module.exports = __webpack_public_path__ + "img/logo.a57dc959.png";